var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "inputs" },
    _vm._l(_vm.count, function(i) {
      return _c("el-input", {
        key: i,
        attrs: { size: "mini", placeholder: "请输入", value: _vm.value[i - 1] },
        on: {
          input: function($event) {
            return _vm.input(i - 1, $event)
          }
        }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }